import React from 'react'

function OverviewPortfolioStrategy({ portfolioStrategy }) {
  return (
    <>
      <div
        className="u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0 u-marginBottom6gu u-paddingBottom6gu"
        id="portfolio-strategy"
      >
        <div className="u-paddingRight2gu u-sizeFill">
          <h3 className="u-marginBottom3gu">Portfolio Strategy</h3>
        </div>
        <div
          className={`Grid js-fund-content`}
          dangerouslySetInnerHTML={{ __html: portfolioStrategy }}
        />
      </div>
    </>
  )
}
export default OverviewPortfolioStrategy
